export interface QueryParams {
  [key: string]: string|string[];
}

/**
 * Extract the list of query parameters from the url.
 */
export function getQueryParams(url: string): QueryParams {
  url = url.split('+').join(' ');

  let params: QueryParams = {};
  let re: RegExp = /[?&]?([^=]+)=([^&]*)/g;
  let tokens;
  // let tokens: RegExpExecArray = re.exec(url);

  while (tokens = re.exec(url)) {
    let key = decodeURIComponent(tokens[1]).toLowerCase();
    let value = decodeURIComponent(tokens[2]);
    // Check if the paramer is an array (like subject[])
    let arrayType = key.substr(key.length - 2) === '[]';

    if (arrayType) {
      key = key.substr(0, key.length - 2);

      const arrayKey: string|string[] = params[key];

      if (Array.isArray(arrayKey)) {
        arrayKey.push(value);
      } else {
        params[key] = [value];
      }
    } else {
      params[key] = value;
    }
  }

  return params;
}
